<template>
    <div class="popover-body">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'PopoverBody'

};
</script>
